"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextWidth = void 0;
const getTextWidth = (text, fontSize = 12) => {
    const avgCharWidth = fontSize;
    return Math.ceil(text.length * avgCharWidth);
};
exports.getTextWidth = getTextWidth;
